<template>
  <div class="submenu_product">
    <div class="submenu promenu1" style="margin-left: -915px; width: 160%">
      <div class="margin">
        <ul class="clear">
          <li v-for="(v,val) in list" :key="val" class="outli">
            <a class="proname">{{ v.name }}</a>
            <ul class="clear">
              <li
                class="clear-l"
                v-for="(vl, index) in v.child.slice(0, 3)"
                :key="index"
                @click="godetail(vl,val,index)"
              >
                <a>
                  <h2>{{ vl.name }}</h2>
                  <p class="boom">{{ vl.name }}</p>
                </a>
              </li>
            </ul>
            <a class="more" style="cursor: pointer" @click="handl(v.id,val)">查看更多 &gt;</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { signCrypto } from "../utils/generateSecretKey";
export default {
  data() {
    return {
      colomn: {},
      title: [],
      list: [],
      tex:""
    };
  },
  methods: {
    handl(v,val){
      this.$router.push({ name: 'design' ,query:{id:v,val}});
      this.$emit('hasUpdatePro', true)
     
      
    },
    godetail(item,val,index) {
      this.$router.push({name:'proDucts',query:{id:item.id,open:val,val:index}})
    },
  },
  watch: {
    "$route.query.id": {
      handler(newVal, oldVal) {
        //判断newVal有没有值监听路由变化
        console.log(newVal, "newVal");
      },
      deep: true,
    },
  },
  created() {
    /* 监听获取数据 */
    let data = JSON.parse(window.sessionStorage.getItem("promenu"));
    if(data){
    this.list = data;
    } else{
      this.$EventBus.$on("promenu",(v)=>{
        this.list = v;
      })
    }
  },
};
</script>

<style lang='stylus' scoped>
.submenu_product {
  /* width: 1200px;
  margin: 0 auto; */
  width: 100%;

  .promenu1 {
    background: rgba(43, 58, 80, 0.5);
    padding: 20px 0;
    position: absolute;
    color: #fff;
    z-index: 99;
    *left: 0px !important;
    margin: 0;
    list-style: none;
    box-sizing: border-box;

    ul {
      .outli {
        width: 240px;
        float: left;

        .proname {
          font-size: 16px;
          line-height: 36px;
          font-weight: 600;
        }

        .clear {
          .clear-l {
            background: #1f3140;
            margin-bottom: 10px;
            font-size: 12px;
            line-height: 24px;
            padding: 8px 0;
            border-radius: 1px;
            float: left;
            position: relative;

            a {
              text-align: center;

              h2 {
                font-size: 14px;
              }

              p {
                color: #888a8d;
              }
            }
          }

          .clear-l:after, .clear-l:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 0;
            height: 100%;
            background: #1f3140;
            z-index: -2;
          }

          .clear-l:hover {
            z-index: 1;
            background: transparent;
            color: #ffffff;
            cursor: pointer;

            .boom {
              color: #ffffff;
            }
          }

          .clear-l:before {
            transition: 0.5s;
            background: #c10000;
            z-index: -1;
          }

          .clear-l:hover:after, .clear-l:hover:before {
            width: 100%;
          }
        }
      }
    }

    .mid {
      display: none;
    }
  }

  .promenu:after, .promenu:before {
    border: 1px solid transparent;
    content: ' ';
    height: 0;
    bottom: 100%;
    position: absolute;
    width: 0;
  }

  .promenu:after {
    border-width: 5px;
    border-bottom-color: #1e374c;
    left: 66%;
  }
}

.boom {
  overflow: hidden;
  width: 200px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/promenu.vue